import React from 'react';
import {
  TRegistrationForm,
  TRegistrationFormValues,
} from './RegistrationForm.types';
import { useForm, Resolver, Controller } from 'react-hook-form';
import { registrationSchema } from './RegistrationForm.schema';
import { yupResolver } from '@hookform/resolvers/yup';
import { REGISTRATION_FORM_DEFAULT_VALUES } from './RegistrationForm.constants';
import { Button, TextInput } from 'components';
import './RegistrationForm.styled.scss';
import { useAppDispatch, useAppSelector } from 'store/store';
import {
  googleAuthAsyncThunk,
  registerUserAsyncThunk,
} from 'store/users/users.action';

import { ModalLayout } from '../../molecules/ModalLayout/ModalLayout';
import { CredentialResponse, GoogleLogin } from '@react-oauth/google';
import { NOTIFICATION_TYPES } from 'store/notifications/notifications.types';
import { pushNotification } from 'store/notifications/notifications.slices';

export const RegistrationForm: TRegistrationForm = ({ closeModal }) => {
  const dispatch = useAppDispatch();
  const { isLoading } = useAppSelector((state) => state.users.registerUser);

  const { control, handleSubmit } = useForm<TRegistrationFormValues>({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    defaultValues: REGISTRATION_FORM_DEFAULT_VALUES,
    resolver: yupResolver(
      registrationSchema
    ) as Resolver<TRegistrationFormValues>,
  });

  const onSubmit = (data: TRegistrationFormValues) => {
    dispatch(
      registerUserAsyncThunk({
        body: data,
        onSuccess: closeModal,
      })
    );
  };

  const onGoogleSuccess = (credentialResponse: CredentialResponse) => {
    dispatch(
      googleAuthAsyncThunk({
        body: { idToken: credentialResponse.credential },
        onSuccess: closeModal,
      })
    );
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="registration-form__form"
      noValidate
    >
      <ModalLayout
        mainContent={
          <>
            <Controller
              control={control}
              name="email"
              render={({ field, fieldState }) => (
                <TextInput
                  {...field}
                  label="Email"
                  placeholder="Enter your email"
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                  required
                />
              )}
            />
            <Controller
              control={control}
              name="password"
              render={({ field, fieldState }) => (
                <TextInput
                  {...field}
                  label="Password"
                  type="password"
                  placeholder="Enter your password"
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                  required
                />
              )}
            />
            <GoogleLogin
              text="signup_with"
              theme="filled_black"
              shape="circle"
              onSuccess={onGoogleSuccess}
              onError={() => {
                dispatch(
                  pushNotification({
                    message: 'Login Failed',
                    type: NOTIFICATION_TYPES.ERROR,
                  })
                );
              }}
            />
          </>
        }
        footerContent={
          <div className="registration-form__actions">
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={isLoading}
            >
              Register
            </Button>
          </div>
        }
      />
    </form>
  );
};
